import { render, staticRenderFns } from "./RealEstateDevelopmentCreateForm.vue?vue&type=template&id=22e6f017"
import script from "./RealEstateDevelopmentCreateForm.vue?vue&type=script&lang=js"
export * from "./RealEstateDevelopmentCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports